module.exports = __webpack_public_path__ + "static/media/searchIcon.f5d08534.svg";